import { bind } from 'lodash-decorators';
export { memoize } from 'lodash-decorators';
export { default as compose } from '@shopify/react-compose';

const autobind = bind();

export { autobind };
